import React, {useEffect, useRef, useState} from 'react'
import './styles.css'
import SilverButton from "../../buttons/SilverButton";
import CheckIcon from "../../../assets/icons/CheckIcon";
import XIcon from "../../../assets/icons/XIcon";
import EditButton from "../../buttons/actions/EditButton";
import DeleteButton from "../../buttons/actions/DeleteButton";
import DestructiveButton from "../../buttons/DestructiveButton";
import EditSquareIcon from "../../../assets/icons/EditSquareIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import Tooltip from "../Tooltip";
import BlueButton from "../../buttons/BlueButton";

const Template = ({
                      text = '',
                      defaultEditable = false,
                      onSave,
                      onDelete,
                      onCancelEdit,
                      readonly = false,
                      onClick = null,
                      ref,
                      style = {},
                      buttonVariants = 'default',
                      textLimit = -1,
                      saveOnUnFocus = false,
                      variant = 'default'
                  }) => {
    const [editable, setEditable] = useState(defaultEditable);
    const [value, setValue] = useState(text);

    const valueBackupRef = useRef(text);
    const ignoreBlurRef = useRef(false);
    const textareaRef = useRef(null);

    useEffect(() => {
        if (editable && textareaRef.current) {
            const el = textareaRef.current;
            el.focus();

            const length = el.value.length;
            el.setSelectionRange(length, length);
        }
    }, [editable]);


    useEffect(() => {
        const el = textareaRef.current;
        if (el) {
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
    }, [value, editable]);

    return (
        <div
            className={`template-container template-container--${variant}${onClick ? ' hoverable' : ''}${editable ? ' is-editing' : ''}`}
            onClick={onClick}
            ref={ref}
            style={style}
        >
            {
                readonly ?
                    <span>{text}</span>
                    : variant === 'management' && !editable ?
                    <div className="template-text">{value}</div>
                    :
                    <textarea
                        ref={textareaRef}
                        value={value}
                        onChange={e => {
                            if(textLimit === -1){
                                setValue(e.target.value)
                            }else{
                                setValue(e.target.value.slice(0, textLimit));
                            }
                        }}
                        disabled={!editable}
                        style={{
                            overflow: 'hidden',
                            resize: 'none',
                        }}
                        rows={1}
                        onKeyDown={(e) => {
                            if (editable && e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                onSave(value);
                                setEditable(false);
                            }
                            if (e.key === 'Escape') {
                                e.preventDefault();
                                setEditable(false);
                                setValue(valueBackupRef.current);
                                if (onCancelEdit && typeof onCancelEdit === 'function') {
                                    onCancelEdit();
                                }
                            }
                        }}
                        onBlur={e => {
                            if (!saveOnUnFocus || ignoreBlurRef.current) return;
                            onSave(value);
                            setEditable(false);
                        }}
                    />
            }


            {
                !readonly &&
                <div className="template-actions">
                    {editable ? (
                        <SilverButton
                            width={'32px'}
                            height={'32px'}
                            onMouseDown={()=>{
                                ignoreBlurRef.current = true;
                            }}
                            onClick={() => {
                                setEditable(false);
                                setValue(valueBackupRef.current);
                                if (onCancelEdit && typeof onCancelEdit === 'function') {
                                    onCancelEdit();
                                }
                                ignoreBlurRef.current = false;
                            }}
                            variant={buttonVariants}
                        >
                            <XIcon width={18} height={18}/>
                        </SilverButton>
                    ) : (
                        variant === 'management' ? (
                            <Tooltip text="remove" deltaY={-7}>
                                <DestructiveButton
                                    type="button"
                                    variant="outline"
                                    size="sm"
                                    iconOnly
                                    width="32px"
                                    onClick={onDelete}
                                >
                                    <DeleteIcon width={18} height={18} stroke="currentColor"/>
                                </DestructiveButton>
                            </Tooltip>
                        ) : (
                            <DeleteButton onClick={onDelete} variant={buttonVariants}/>
                        )
                    )}

                    {editable ? (
                        <SilverButton
                            width={'32px'}
                            height={'32px'}
                            onClick={() => {
                                onSave(value);
                                setEditable(false);
                            }}
                            variant={buttonVariants}
                        >
                            <CheckIcon width="18" height="18" className="save-icon"/>
                        </SilverButton>
                    ) : (
                        variant === 'management' ? (
                            <Tooltip text="edit" deltaY={-7}>
                                <SilverButton
                                    type="button"
                                    variant="soft"
                                    size="sm"
                                    iconOnly
                                    width="32px"
                                    onClick={() => {
                                        valueBackupRef.current = value
                                        setEditable(true);
                                    }}
                                >
                                    <EditSquareIcon width={18} height={18} stroke="currentColor"/>
                                </SilverButton>
                            </Tooltip>
                        ) : (
                            <EditButton
                                onClick={() => {
                                    valueBackupRef.current = value
                                    setEditable(true);
                                }}
                                variant={buttonVariants}
                            />
                        )
                    )}
                </div>
            }

        </div>
    );
};

export default Template;



// WEBPACK FOOTER //
// ./src/components-new/general/Template/index.jsx